import * as React from 'react';

import BarChart from './Barchart';
import {
	Box,
	Table,
	TableBody,
	TableHead,
	TableRow,
	ThemeProvider,
	Typography,
} from '@mui/material';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import PropTypes from 'prop-types';
import { theme } from '../../../../theme/theme';
import { colors } from '../../../../theme/color-palette';
import { colorCoding, getIcon } from '../../../../helper/getIcon';

export default function CBTable(props) {
	const { chartData, headers, height } = props;

	const getLegend = (color, name, position = 'left') => {
		return (
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					marginRight: position === 'left' ? '16px' : 0,
				}}>
				<Box
					sx={{
						height: '6px',
						width: '16px',
						backgroundColor: color,
						marginRight: '8px',
					}}
				/>
				<Typography
					sx={{
						fontSize: '12px !important',
						fontWeight: '400 !imporant',
						lineHeight: '16px',
						color: colors.FONT_COLOR,
					}}>
					{name}
				</Typography>
			</Box>
		);
	};

	return (
		<ThemeProvider theme={theme}>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					height: height ? '432px !imporant' : '310px !important',
					width: '100%',
				}}>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'flex-start',
						marginTop: '0px',
						justifyContent: 'flex-start',
					}}>
					<Table
						sx={{
							[`& .${tableCellClasses.root}`]: {
								borderBottom: 'none',
							},
							flexShrink: 15,
							flexGrow: 0,
							flexBasis: '370px',
							minWidth: '370px',
							height: '252px',
						}}
						size="small"
						aria-label="a dense table">
						<TableHead>
							<TableRow
								sx={{
									height: '16px',
								}}>
								{headers?.map((header, idx) => {
									return (
										header?.showOnDashboard && (
											<TableCell
												sx={{
													width: idx === 0 ? '100px !imporant' : 'auto',
													minWidth: '35px !imporant',
													paddingRight: 0,
													paddingLeft: 0,
												}}
												align={header.align}
												key={`${header.value}_${idx}`}>
												<Typography
													sx={{
														fontSize: '14px !imporant',
														fontWeight: '700 !imporant',
													}}>
													{header.label}
												</Typography>
											</TableCell>
										)
									);
								})}
							</TableRow>
						</TableHead>
						<TableBody>
							{chartData?.map((row) => (
								<TableRow key={row.name} sx={{}}>
									{headers
										?.filter((header) => header.showOnDashboard === true)
										.map((header, idx) => (
											<TableCell
												key={`${row.name}_${idx}`}
												align="right"
												sx={{
													width: idx === 0 ? '100px !imporant' : 'auto',
													paddingRight: 0,
													paddingLeft: 0,
													paddingTop: 0,
													paddingBottom: '0px',
												}}>
												<Typography
													sx={{
														fontSize: '14px !important',
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'flex-end',
														fontWeight:
															idx === 0 ? '700  !important' : '500  !important',
														color: colorCoding(row[`${header.value}Sign`]),
													}}>
													{header.value === 'yoy' &&
														getIcon(row[`${header.value}Sign`])}
													{header.valueRenderer(row[`${header.value}`])}
												</Typography>
											</TableCell>
										))}
								</TableRow>
							))}
						</TableBody>
					</Table>
					<Box
						sx={{
							flexGrow: 15,
							flexShrink: 0,
							height: '100%',
							flexBasis: '300px',
						}}>
						<BarChart chartData={chartData} />
					</Box>
				</Box>
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						marginBottom: '17px !imporant',
					}}>
					{getLegend(colors.PURPLE_ACTIVE, 'This year', 'left')}
					{getLegend(colors.PURPLE_GRAY, 'Last year', 'right')}
				</Box>
			</Box>
		</ThemeProvider>
	);
}

CBTable.propTypes = {
	chartData: PropTypes.arrayOf(PropTypes.shape({})),
	headers: PropTypes.arrayOf(PropTypes.shape({})),
	height: PropTypes.string,
};
